import React from "react";
import { Navigate } from "react-router-dom";

// import { getAuth } from '@/selectors'

interface PublicRouteProps {
    component: any;
    path: string;
    layout: any;
    authenticatedRedirect: boolean;
}

const PublicRoute: React.FC<PublicRouteProps> = ({
    component,
    path,
    layout,
    authenticatedRedirect,
    ...rest
}) => {
    const isAuthenticated = Boolean(localStorage.getItem("sid"));
    return !(isAuthenticated && authenticatedRedirect) ? (
        React.createElement(layout, {}, React.createElement(component, {}))
    ) : (
        <Navigate to="/" />
    );
};

export default PublicRoute;
